import { Routes } from '@angular/router';
import { RequestsComponent } from './requests/requests.component';
import { RequestDetailComponent } from './requests/request-detail/request-detail.component';
import { PortalsComponent } from './portals/portals.component';
import { PortalsResolveService } from './core/services/portals.resolve.service';
import { RequestDetailEmptyComponent } from './requests/request-detail-empty/request-detail-empty.component';
import { NotFoundPageComponent } from '@sb-tools/typescript/components/error-pages/not-found-page/not-found-page.component';

export const routes: Routes = [
    {
        path: '404',
        component: NotFoundPageComponent,
    },
    {
        path: ':communityName',
        redirectTo: ':communityName/portals',
        pathMatch: 'full',
    },
    {
        path: ':communityName/portals',
        component: PortalsComponent,
    },
    {
        path: ':communityName/:portalName',
        redirectTo: ':communityName/:portalName/requests',
        pathMatch: 'full',
    },
    {
        path: ':communityName/:portalName/requests',
        component: RequestsComponent,
        data: {
            name: 'requests',
        },
        resolve: {
            currentPortal: PortalsResolveService,
        },
        children: [
            {
                path: '',
                component: RequestDetailEmptyComponent,
            },
            {
                path: 'detail/:id',
                component: RequestDetailComponent,
            },
        ],
    },
    {
        path: '**',
        component: NotFoundPageComponent,
    },
];
